import { createMemoryHistory, createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import useAuth from './composables/useAuth'


import {
    MainScreen,
    AuthenticationSignInMentorScreen,
    AuthenticationSignInScreen,
    AuthenticationSignUpScreen,
    AuthenticationVerifyEmail,
    AuthenticationVerifyWhatsapp,
    // CourseDiscoveryDummyScreen,
    // CourseDetailDummyScreen,
    CourseDiscoveryScreen,
    CourseDetailScreen,
    // CourseLearningDummyScreen,
    CourseLearningScreen,
    // ProgramDiscoveryDummyScreen,
    // ProgramDetailsDummyScreen,
    ProgramDiscoveryScreen,
    ProgramDetailScreen,
    ProgramMeetingScreen,
    MentorInternalCoreScreen,
    MentorInternalAvailabilityScreen,
    MentorInternalScheduleScreen,
    InternalCoreScreen,
    AuthenticationForgotRequest,
    AuthenticationForgotNotif,
    AuthenticationForgotReset,
    // InternalCourseDummyScreen,
    InternalCourseScreen,
    // InternalProgramListDummyScreen,
    InternalProgramListScreen,
    InternalWebinarScreen,
    InternalCalendarScreen,
    InternalNotificationScreen,
    // InternalProgramDetailDummyScreen,
    InternalProgramDetailScreen,
    InternalPerformanceScreen,
    // InternalPerformanceDummyScreen,
    InternalAccountScreen,
    AboutScreen,
    Client,
    Graduates,
    MovedPermantly,
    NotFound,
    EventDetailScreen
} from "./screen"
import { message } from 'ant-design-vue'
import AuthApi from './api/auth'



const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'MainScreen',
        component: MainScreen,
        meta: {
            seoSlug: 'home',
            seoType: 'pages',
            headingTitle: 'Empowering Social Enterprise to Scale up with Business Purpose and Lead with Impact.'
        }
    },
    {
        path: '/About',
        name: 'AboutScreen',
        component: AboutScreen,
        meta: {
            seoSlug: 'about',
            seoType: 'pages',
            headingTitle: 'Our vision is to create a world where businesses operate responsibly, motivated by purpose and positive impact'
        }
    },
    {
        path: '/Client',
        name: 'ClientScreen',
        component: Client,
        meta: {
            seoSlug: 'partners',
            seoType: 'pages',
            headingTitle: 'Our Partners'
        }
    },
    {
        path: '/Graduates',
        name: 'GraduatesScreen',
        component: Graduates,
        meta: {
            seoSlug: 'graduates',
            seoType: 'pages',
            headingTitle: 'Our Graduates'
        }
    },
    {
        path: '/Event/Detail/:EventID',
        name: 'EventDetailScreen',
        component: EventDetailScreen,
        meta: {
            seoSlug: 'articles',
            seoType: 'detail',
            seoParamsName: 'EventID'
        }
    },
    {
        path: '/Mentor/SignIn',
        name: 'AuthenticationSignInMentorScreen',
        component: AuthenticationSignInMentorScreen
    },
    {
        path: '/SignIn',
        name: 'AuthenticationSignInScreen',
        component: AuthenticationSignInScreen,
        meta: {
            seoSlug: 'signin',
            seoType: 'pages',
            headingTitle: 'Start turning your ideas into reality.'
        }
    },
    {
        path: '/SignUp',
        name: 'AuthenticationSignUpScreen',
        component: AuthenticationSignUpScreen,
        meta: {
            seoSlug: 'signup',
            seoType: 'pages',
            headingTitle: 'Start turning your ideas into reality.'
        }
    },
    {
        path: '/Forgot/Request',
        name: 'AuthenticationForgotRequest',
        component: AuthenticationForgotRequest
    },
    {
        path: '/Forgot/Notif',
        name: 'AuthenticationForgotNotif',
        component: AuthenticationForgotNotif
    },
    {
        path: '/Forgot/Reset',
        name: 'AuthenticationForgotReset',
        component: AuthenticationForgotReset
    },
    {
        path: '/Verify/Email',
        name: 'AuthenticationVerifyEmail',
        component: AuthenticationVerifyEmail
    },
    {
        path: '/Verify/Whatsapp',
        name: 'AuthenticationVerifyWhatsapp',
        component: AuthenticationVerifyWhatsapp
    },
    // {
    //     path: '/Dummy/Course/Discovery',
    //     name: 'CourseDiscoveryDummyScreen',
    //     component: CourseDiscoveryDummyScreen
    // },
    // {
    //     path: '/Dummy/Course/Detail/:CourseID',
    //     name: 'CourseDetailDummyScreen',
    //     component: CourseDetailDummyScreen
    // },
    {
        path: '/Course/Discovery',
        name: 'CourseDiscoveryScreen',
        component: CourseDiscoveryScreen,
        meta: {
            seoSlug: 'courses',
            seoType: 'pages',
            headingTitle: 'Our Course'
        }
    },
    {
        path: '/Course/Detail/:CourseID',
        name: 'CourseDetailScreen',
        component: CourseDetailScreen,
        meta: {
            seoSlug: 'course',
            seoType: 'detail',
            seoParamsName: 'CourseID'
        }
    },
    // {
    //     path: '/Dummy/Course/Learning/:CourseID',
    //     name: 'CourseLearningDummyScreen',
    //     component: CourseLearningDummyScreen
    // },
    {
        path: '/Course/Learning/:CourseID',
        name: 'CourseLearningScreen',
        component: CourseLearningScreen
    },
    // {
    //     path: '/Dummy/Program/Discovery',
    //     name: 'ProgramDiscoveryDummyScreen',
    //     component: ProgramDiscoveryDummyScreen
    // },
    // {
    //     path: '/Dummy/Program/Detail/:ProgramID',
    //     name: 'ProgramDetailsDummyScreen',
    //     component: ProgramDetailsDummyScreen
    // },
    {
        path: '/Program/Discovery',
        name: 'ProgramDiscoveryScreen',
        component: ProgramDiscoveryScreen,
        meta: {
            seoSlug: 'programs',
            seoType: 'pages',
            headingTitle: 'Our Program'
        }
    },
    {
        path: '/Program/Detail/:ProgramID',
        name: 'ProgramDetailScreen',
        component: ProgramDetailScreen,
        meta: {
            seoSlug: 'program',
            seoType: 'detail',
            seoParamsName: 'ProgramID'
        }
    },
    {
        path: '/Program/Meeting/:ProgramID',
        name: 'ProgramMeetingScreen',
        component: ProgramMeetingScreen
    },
    {
        path: '/Mentor/Internal/Core',
        name: 'MentorInternalCoreScreen',
        component: MentorInternalCoreScreen,
    },
    {
        path: '/Mentor/Internal/Availability',
        name: 'MentorInternalAvailabilityScreen',
        component: MentorInternalAvailabilityScreen,
    },
    {
        path: '/Mentor/Internal/Schedule',
        name: 'MentorInternalScheduleScreen',
        component: MentorInternalScheduleScreen,
    },
    {
        path: '/Mentor/Internal/Notification',
        name: 'MentorInternalNotificationScreen',
        component: InternalNotificationScreen,
    },
    {
        path: '/Mentor/Internal/Calendar',
        name: 'MentorInternalCalendarScreen',
        component: InternalCalendarScreen,
    },
    {
        path: '/Internal/Core',
        name: 'InternalCoreScreen',
        component: InternalCoreScreen,
    },
    // {
    //     path: '/Dummy/Internal/Course',
    //     name: 'InternalCourseDummyScreen',
    //     component: InternalCourseDummyScreen,
    // },
    {
        path: '/Internal/Course',
        name: 'InternalCourseScreen',
        component: InternalCourseScreen,
    }, 
    // {
    //     path: '/Dummy/Internal/Program',
    //     name: 'InternalProgramListDummyScreen',
    //     component: InternalProgramListDummyScreen,
    // },
    {
        path: '/Internal/Program',
        name: 'InternalProgramListScreen',
        component: InternalProgramListScreen,
    },
    // {
    //     path: '/Dummy/Internal/Program/Detail/:ProgramID',
    //     name: 'InternalProgramDetailDummyScreen',
    //     component: InternalProgramDetailDummyScreen,
    // },
    {
        path: '/Internal/Program/Detail/:ProgramID',
        name: 'InternalProgramDetailScreen',
        component: InternalProgramDetailScreen,
    },
    {
        path: '/Internal/Account',
        name: 'InternalAccountScreen',
        component: InternalAccountScreen,
    },
    {
        path: '/Internal/Webinar',
        name: 'InternalWebinarScreen',
        component: InternalWebinarScreen,
    },
    {
        path: '/Internal/Notification',
        name: 'InternalNotificationScreen',
        component: InternalNotificationScreen,
    },
    {
        path: '/Internal/Calendar',
        name: 'InternalCalendarScreen',
        component: InternalCalendarScreen,
    },
    {
        path: '/Internal/Performance',
        name: 'InternalPerformanceScreen',
        component: InternalPerformanceScreen,
    },
    // {
    //     path: '/Dummy/Internal/Performance',
    //     name: 'InternalPerformanceDummyScreen',
    //     component: InternalPerformanceDummyScreen,
    // },
    {
        path: '/NotFound',
         name: 'NotFound',
        component: NotFound
    },
    {
        path: '/:catchAll(.*)',
         name: 'MovedPermantly',
        component: MovedPermantly
    },
]

export function createAppRouter() {
    const isServer = typeof window === 'undefined'

    const router = createRouter({
        history: isServer ? createMemoryHistory() : createWebHistory(),
        routes,
        scrollBehavior() {
            return false;
        }
    })

    router.afterEach(() => {
        if (!isServer) {
            window.scrollTo({
            top: 0,
            behavior: "smooth",
            });
        }
    });
    router.beforeEach((to, from, next) => {
    
        const authRoutes = ['AuthenticationSignInScreen', 'AuthenticationSignUpScreen', 'AuthenticationSignInMentorScreen', 'AuthenticationForgotRequest', 'AuthenticationForgotNotif', 'AuthenticationForgotReset'];

        const auth = useAuth().get();
        const isAuthenticated = auth.authenticated;
        const isMentor = auth.isMentor === 'true';
        const toPath = to.path.toLowerCase();
        const isMentorInternalPath = toPath.startsWith('/mentor/internal');
        const isInternalPath = toPath.startsWith('/internal');

        const user = auth.user ? JSON.parse(JSON.parse(auth.user)) : null;

        if (!user?.gender && !isMentor && isAuthenticated && isInternalPath && to.name !== 'InternalAccountScreen') {
            next({ name: 'InternalAccountScreen' });
        }
        else if (authRoutes.includes(to.name as string) && isAuthenticated) {
            next({ name: isMentor ? 'MentorInternalCoreScreen' : 'InternalCoreScreen' });
        } else if (isAuthenticated && isMentorInternalPath && !isMentor) {
            next({ name: 'InternalCoreScreen' });
        } else if (isAuthenticated && isInternalPath && isMentor) {
            next({ name: 'MentorInternalCoreScreen' });
        } else if (isMentorInternalPath && !isAuthenticated) {
            next({ name: 'AuthenticationSignInMentorScreen' });
        } else if (isInternalPath && !isAuthenticated) {
            next({ name: 'AuthenticationSignInScreen' });
        } else {
            next();
        }
    
    
    });

    return router
}


// export default router
